import React, { useEffect, isValidElement, useState } from 'react';
import SaveRef from './SaveRef.jsx';
import ScrollableTabBarNode from './ScrollableTabBarNode.jsx';
import TabBarTabsNode from './TabBarTabsNode.jsx';
import Util from '../../script/util';
import './index.scss';

const customRenderTabBar = ({ onScroll, ...otherProps }) => {
  const [extra, setExtra] = useState(null);

  useEffect(() => {
    if (otherProps?.extra) {
      setExtra({ right: restProps.extra });
    }
  }, [otherProps.extra]);

  const restProps = {
    prefixCls: 'ant-tabs',
    tabBarPosition: 'top',
    ...otherProps,
  };
  const cls = Util.classNames({
    [restProps.prefixCls]: 1,
    [`${restProps.prefixCls}-${restProps.tabBarPosition}`]: 1,
    [`${restProps.prefixCls}-rtl`]: restProps.direction === 'rtl',
    [`${restProps.prefixCls}-extra`]: !!extra,
  });
  return (
    <div className={cls} onScroll={onScroll}>
      <SaveRef>
        {(saveRef, getRef) => (
          <>
            <ScrollableTabBarNode
              saveRef={saveRef}
              getRef={getRef}
              {...restProps}
            >
              <TabBarTabsNode saveRef={saveRef} {...restProps} />
            </ScrollableTabBarNode>
            <ExtraContent
              position="right"
              extra={extra}
              prefixCls={restProps.prefixCls}
            />
          </>
        )}
      </SaveRef>
    </div>
  );
};

export default customRenderTabBar;

const ExtraContent = ({ position, prefixCls, extra }) => {
  if (!extra) return null;

  let content;

  // Parse extra
  let assertExtra = {};
  if (extra && typeof extra === 'object' && !isValidElement(extra)) {
    assertExtra = extra;
  } else {
    assertExtra.right = extra;
  }

  if (position === 'right') {
    content = assertExtra.right;
  }

  if (position === 'left') {
    content = assertExtra.left;
  }

  return content ? (
    <div className={`${prefixCls}-extra-content`}>{content}</div>
  ) : null;
};
